// extracted by mini-css-extract-plugin
module.exports = {"container":"BoostsHeader_container__14ezX"};